module.exports = __webpack_public_path__ + "img/tire-rugged.34626317.svg";